import { useAlert } from 'providers/AlertModalProvider';
import { useModal } from 'providers/ConfirmationModalProvider';
import postData from 'services/postData';

const useHandleDelete = () => {
  const { showConfirmation } = useModal();
  const { showAlert } = useAlert();

  const handleDeleteData = async ({
    label,
    name,
    url,
    handleLoading,
    handleRefresh,
    payLoad
  }) => {
    showConfirmation({
      onConfirm: async () => {
        handleLoading(true, 'Deleting');
        const requestStatus = await postData(
          { ...payLoad, _method: 'DELETE' },
          url,
          {
            method: 'POST',
            requestBodyMethod: 'form-data'
          }
        );
        if (requestStatus.status) {
          handleLoading(false);
          showAlert({
            variant: 'success',
            message: `Successfully deleted ${label} ${name}.`
          });
          handleRefresh();
        } else {
          if (requestStatus.message?.includes('flag has already')) {
            handleLoading(false);
            showAlert({
              variant: 'warning',
              message: `Failed to delete the ${label}; this ${label} approval is pending.`
            });
            handleRefresh();
          } else {
            handleLoading(false);
            showAlert({
              variant: 'danger',
              message: `Failed to  delete the ${label} ${name}. Please try again.`
            });
          }
        }
      },
      message: `Are you sure you want to delete the ${label} ${name}?`,
      severity: 'danger',
      confirmBtn: 'Delete'
    });
  };

  return handleDeleteData;
};

export default useHandleDelete;
